module.exports = __webpack_public_path__ + "static/media/sun.19f21d1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/sun.svg
// module id = 878
// module chunks = 0